import { Module } from 'vuex-smart-module';
import AlfaApiLoanApplicationStatusesActions from './actions';
import AlfaApiLoanApplicationStatusesGetters from './getters';
import AlfaApiLoanApplicationStatusesMutations from './mutations';
import AlfaApiLoanApplicationStatusesState from './state';

export default new Module({
  state: AlfaApiLoanApplicationStatusesState,
  mutations: AlfaApiLoanApplicationStatusesMutations,
  actions: AlfaApiLoanApplicationStatusesActions,
  getters: AlfaApiLoanApplicationStatusesGetters,
});
